import styled from 'styled-components'

export default styled.label`
  font-size: 15px;
  font-weight: 500;
  display: block;
  margin-bottom: 5px;
`
